import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { CloseButton } from './CloseButton';
import { CloseIcon } from './CloseIcon';
import { ScanAlertMessages, ScanAlerts } from './ScanAlerts';

const styles = {
  content: {
    px: 3,
  },
  footer: {
    bottom: 0,
    position: 'fixed',
    px: 3,
    width: '100%',
    zIndex: 2,
  },
  header: {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2,
  },
  root: {
    backgroundColor: 'black',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 1,
  },
  title: {
    '& h6': {
      pb: 0.5,
    },
    color: 'white',
    pb: 4,
    textAlign: 'center',
  },
} as const;

interface QRScanMobileLayoutProps {
  error: string;
  onClose: () => void;
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
  scanAlertsMessages: ScanAlertMessages;
  closeButtonLabel: ReactNode;
}

export function QRScanMobileLayout({
  children,
  closeButtonLabel,
  description,
  error,
  onClose,
  scanAlertsMessages,
  title,
}: QRScanMobileLayoutProps) {
  return (
    <Box sx={styles.root}>
      {children}
      <Box sx={styles.header}>
        <CloseIcon onClick={onClose} />
        <Box sx={styles.content}>
          <Box sx={styles.title}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body2">{description}</Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={styles.footer}>
        <ScanAlerts error={error} messages={scanAlertsMessages} />
        <CloseButton onClick={onClose} label={closeButtonLabel} />
      </Box>
    </Box>
  );
}
